var map = {
	"./ISO.webp": 5577,
	"./Registration.webp": 8621,
	"./anz_certificate.webp": 5103,
	"./icsi_certificate.webp": 6920,
	"./redis_certificate.webp": 675,
	"./skillfront_certificate.webp": 1344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9980;